export const ALL_LANGUAGES = ['en'];
const BCP47_BY_SHORT = {
    en: 'en-US',
};
const SHORT_ALIASES = {};
export const isLanguageCode = (value) => ALL_LANGUAGES.includes(value);
export const toShortCode = (value) => {
    if (typeof value !== 'string')
        return null;
    const lower = value.split('-')[0]?.toLowerCase() ?? '';
    if (isLanguageCode(lower))
        return lower;
    const aliased = SHORT_ALIASES[lower];
    return aliased ?? null;
};
export const toBcp47 = (code) => BCP47_BY_SHORT[code];
export const pickTranslation = (field, locale, fallback = ALL_LANGUAGES[0]) => {
    if (!field)
        return '';
    const short = toShortCode(locale) ?? fallback;
    return field[short] ?? field[fallback] ?? Object.values(field)[0] ?? '';
};
//# sourceMappingURL=locales.js.map